export * from './main-menu.module';

export * from './main-menu.component';
